module.exports = __webpack_public_path__ + "img/smartTV.9f5faf24.svg";